import React, { useEffect } from "react";
import NoteItem from "./NoteItem";
import { fetchNotes } from "./note-slice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { Divider, makeStyles, MessageBar, MessageBarBody, Spinner, Text } from "@fluentui/react-components";
import { getEntityId } from "../../utils/Helpers";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  noteItem: {
    paddingTop: "10px",

    "&:first-child": {
      paddingTop: "0",
    },
  },
  text: {
    margin: "0",
  },
});

const Notes = ({ uid, entity }) => {
  const styles = useStyles();
  const dispatch: AppDispatch = useDispatch();
  const { notes, loading } = useSelector((state: RootState) => state.notes);

  useEffect(() => {
    if (uid) {
      const entityId = getEntityId(entity);
      dispatch(fetchNotes({ entityId, objectUid: uid }));
    }
  }, [dispatch, uid, entity]);

  return (
    <div>
      <div className={styles.container}>
        {loading ? (
          <Spinner />
        ) : (
          <div>
            {notes.length > 0 ? (
              notes.map((note, index) => (
                <div key={index} className={styles.noteItem}>
                  <NoteItem note={note} />
                  {index < notes.length - 1 && <Divider />}
                </div>
              ))
            ) : (
              <MessageBar intent="info">
                <MessageBarBody>
                  <Text as="p" block className={styles.text}>
                    No notes found for this entity.
                  </Text>
                </MessageBarBody>
              </MessageBar>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Notes;
